/**
 * Created by hernanherreros on 2019-05-27
 */

import * as React from 'react'
import Lottie from 'react-lottie'

interface Props {
  animation: any;
  width: string | number;
  height: string | number;
  loop: boolean;
}

export default class LottieAnimation extends React.Component<Props> {
  static defaultProps = {
    width: '100%',
    height: 'auto',
    loop: true,
  }

  render() {
    const { animation, width, height, loop } = this.props

    return (
      <Lottie
        isClickToPauseDisabled
        options={defaultOptions(animation, loop)}
        width={width}
        height={height}

      />
    )
  }
}

const defaultOptions = (animation: any, loop: boolean) => ({
  loop: loop,
  autoplay: true,
  animationData: animation,
})